<template>
  <div class="pgnnp-audio-ad">
    <div class="audio-image">
      <a v-if="isDisplayBtn" href="#" class="btn-close" @click.prevent.stop="closeAudioMask">
        <i class="material-icons">
          close
        </i>
      </a>
      <img :src="pgnnpAudio.images && pgnnpAudio.images[1].url" @click="clickAD">
    </div>
    <!-- template content  -->
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'PgnnpAudioAd',
  components: {},
  directives: {
    // ImgLazyLoader
  },
  props: {},
  data() {
    return {
      isDisplayBtn: false
    }
  },
  computed: {
    ...mapState({
      // Namespacing
      pgnnpAudio: state => state.player.pgnnpAudio,
      pgnnpAudioMask: state => state.player.pgnnpAudioMask
    })
  },
  watch: {},
  created() {},
  mounted() {
    setTimeout(() => {
      this.displayCloseBtn()
    }, 3000)
  },
  updated() {},
  methods: {
    async clickAD () {
      await window.PgnnpSDK.sendAudioAdClicked(this.pgnnpAudio.session)
      await window.PgnnpSDK.clickToCPALink({
        session: this.pgnnpAudio.session,
        adID: this.pgnnpAudio.id,
        link: this.pgnnpAudio.link
      })
      window.open(this.pgnnpAudio.link, '_blank')
    },
    displayCloseBtn () {
      this.isDisplayBtn = true
    },
    closeAudioMask() {
      this.$store.commit('PGNNP_AUDIO_MASK', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.pgnnp-audio-ad {
  display: table;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  text-align: center;
  .audio-image{
    display: inline-block;
    position: relative;
    width: 30vh;
    height: 30vh;
    text-align: center;
    vertical-align: middle;
    top: calc(50vh - 15vh);
    .btn-close{
      display: inline-block;
      position: absolute;
      top: 8px;
      right: 8px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #fff;
      font-size: 20px;
      padding: 3px;
      color: $grey-7d;
      vertical-align: middle;
      z-index: 1;
    }
    img{
      height: 100%;
      width: auto;
      cursor: pointer;
    }
  }
  &:after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #fff;
    opacity: .85;
    z-index: -1;
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .pgnnp-audio-ad {
    .audio-image{
      width: 100%;
      height: auto;
      top: 22vh;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
